import { useCallback, useEffect, useState } from 'react'
import { useDeleteWellData } from '../../hooks/use-api'
import { ERROR_MESSAGES } from '../errors/messages'
import {
  Button,
  ButtonsContainer,
  createToastMessage,
  FormField,
  Heading,
  InlineNotification,
  Modal,
  ReadOnlyField,
  TextInput,
  ToastMessage,
} from '@msaf/core-react'

export function DeleteAPIClientModel({
  onRequestClose,
  id,
  name,
}: {
  id: string
  name: string
  onRequestClose: VoidFunction
}) {
  const [confirmName, setConfirmName] = useState('')
  const { mutate, isError, isSuccess, error, isLoading } = useDeleteWellData()
  const allowDelete = confirmName === name

  useEffect(() => {
    if (isError && error) {
      createToastMessage(<ToastMessage messageType='error' title='Error' message={ERROR_MESSAGES.DELETE_FAILED} />)
    }
  }, [isError, error])

  useEffect(() => {
    if (isSuccess) {
      createToastMessage(<ToastMessage messageType='success' title='Success' message='API Client deleted' />)
      onRequestClose()
    }
  }, [isSuccess, onRequestClose])

  const submit = useCallback(
    (e?: React.FormEvent<HTMLElement>) => {
      e?.preventDefault()
      if (!allowDelete) return
      try {
        mutate(`users/api-client/${id}`)
      } catch (e) {
        createToastMessage(<ToastMessage messageType='error' title='Error' message={ERROR_MESSAGES.DELETE_FAILED} />)
      }
    },
    [mutate, allowDelete, id],
  )

  return (
    <Modal isOpen={true} onRequestClose={onRequestClose} contentLabel={''}>
      <Heading level={1}>Delete API Client</Heading>
      <form onSubmit={submit}>
        <InlineNotification messageType='warning' isDismissable={false}>
          This delete the API client permanently. Any applications using this client will no longer be able to access
          the API.
          <br />
          <br />
          Are you sure you wish to proceed?
        </InlineNotification>
        <FormField label='Name' labelId='name'>
          <ReadOnlyField labelledBy='name' value={name} />
        </FormField>

        <FormField label='Confirm name' labelId='confirm-name' isRequired>
          <TextInput
            id='confirm-name'
            value={confirmName}
            autoFocus={true}
            setValue={() => {}} /* Ignore this as we are using the change handler */
            onChange={(e) => setConfirmName(e.target.value)}
            isDisabled={isLoading}
          />
        </FormField>

        <ButtonsContainer containerStyle='right'>
          <Button
            label='Delete'
            isDisabled={!allowDelete || isLoading}
            type='button'
            onClick={submit}
            buttonStyle='primary'
          />
          <Button
            label='Cancel'
            type='button'
            buttonStyle='text-action'
            onClick={onRequestClose}
            isDisabled={isLoading}
          />
        </ButtonsContainer>
      </form>
    </Modal>
  )
}
